if (!customElements.get('section-modal')) {
  class SectionModal extends HTMLElement {
    constructor() {
      super();
      this.modalOverlay = this.querySelector('.js-modal-overlay');
      this.closeButton = this.querySelector('.js-modal-close');
      
      if (this.modalOverlay) {
        this.modalOverlay.addEventListener('click', this.close.bind(this));
      }
      
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.close.bind(this));
      }

      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close();
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.activeElement = triggeredBy;
      
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');
      
      // Trap focus logic (optional but recommended for accessibility)
      if (typeof trapFocus === 'function') {
        trapFocus(this, this.querySelector('.drawer__inner'));
      }
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      
      if (typeof removeTrapFocus === 'function' && this.activeElement) {
        removeTrapFocus(this.activeElement);
      }
    }
  }

  customElements.define('section-modal', SectionModal);
}

document.addEventListener('DOMContentLoaded', () => {
  const openButtons = document.querySelectorAll('.js-open-modal');
  openButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      const modalId = button.getAttribute('aria-controls');
      const modal = document.getElementById(modalId);
      if (modal && typeof modal.open === 'function') {
        modal.open(button);
      }
    });
  });
});
